import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { CLIENT_BUILD_TIME } from '../build-time';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
  readonly updateRequired$ = new Subject<void>();

  private lastCheckedAt = 0;
  private isUpdateRequired = false;
  private readonly checkIntervalMs = 10 * 60 * 1000;

  constructor(private http: HttpClient) {}

  get updateRequired(): boolean { return this.isUpdateRequired; }

  checkVersionIfNeeded(): Observable<boolean> {
    if (this.isUpdateRequired) return of(false);

    const now = Date.now();
    if ((now - this.lastCheckedAt) < this.checkIntervalMs) return of(true);

    // Set optimistically to prevent concurrent duplicate checks.
    this.lastCheckedAt = now;

    // CLIENT_BUILD_TIME is compiled directly into this bundle (see write-build-time.js, run by
    // the prebuild npm script) - no network call needed to know what this tab is running, only
    // for what the server currently has. This also means this service's constructor does
    // nothing but the plain DI assignment - no eager HTTP call, no subscribe() on construction.
    // An earlier attempt at eagerly fetching the client version in this constructor broke login
    // entirely (see the CLAUDE memory note on this) - keep it that way.
    return this.http.get<{ buildTime: number }>(`/charitycentral/checkversion?v=${Date.now()}`).pipe(
      tap(serverVersion => {
        if (serverVersion.buildTime !== 0 && serverVersion.buildTime !== CLIENT_BUILD_TIME) {
          this.isUpdateRequired = true;
          this.updateRequired$.next();
        }
      }),
      map(() => !this.isUpdateRequired),
      catchError(() => of(true))
    );
  }
}
